// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivacyPolicy_container__2sydW","bigTitle":"PrivacyPolicy_bigTitle__18eeA","ltr":"PrivacyPolicy_ltr__2ejYZ"};